import { getCheckRequestTemplate } from "../../utils/checkRequestTemplates";
import { getEmergencyTemplate } from "../../utils/emergencyTemplates";
import { getMasterTemplate } from "../../utils/masterTemplates";
import types from "../../utils/testTypes";

export function getTemplate(check, subscenario, options = {}) {
  switch (check) {
    case types.default_on:
      return { ...defaultOnTemplate };
    case types.emergency:
      return { ...getEmergencyTemplate(subscenario) };
    case types.master:
      return { ...getMasterTemplate() };
    case types.check_request:
      return {
        ...getCheckRequestTemplate(subscenario, options.supportedFlushes),
      };
    case types.reset_wifi:
      return { ...resetWifiTemplate };
    case types.termination:
      return { ...terminationTemplate };
    case types.dnd: {
      const template = { ...dndTemplate };
      if (options.hasAudio === false) {
        template["voice prompt"] = {
          name: "voice prompt",
          status: "waiting",
          comments: "Skipped on Gauge-ro 2.0 (no audio)",
        };
      }
      return template;
    }
    case types.reboot:
      return { ...rebootTemplate };
    case types.pulse_calibration:
      return { ...pulseCalibrationTemplate };
    default:
      return null;
  }
}

const defaultOnTemplate = {
  connectivity: {
    name: "connectivity",
    status: "running",
  },
  "default on payload": {
    name: "default on payload",
    status: "waiting",
  },
  "default on": {
    name: "default on",
    status: "waiting",
  },
  "sediment flush": {
    name: "sed flush",
    status: "waiting",
  },
  completed: {
    name: "return to default on",
    status: "waiting",
  },
};

const resetWifiTemplate = {
  connectivity: {
    name: "connectivity",
    status: "running",
  },
  "reset wifi payload": {
    name: "reset wifi payload",
    status: "waiting",
  },
  disconnection: {
    name: "disconnection",
    status: "waiting",
  },
  "reconnect wifi": {
    name: "reconnect wifi",
    comments: "Please reconnect wifi by going to 192.168.4.1 or using app",
    input: {
      clicked: false,
      dependency: "disconnection",
    },
  },
  reconnection: {
    name: "reconnection",
    status: "waiting",
  },
};

const terminationTemplate = {
  connectivity: {
    name: "connectivity",
    status: "running",
  },
  "flush start": {
    name: "flush start",
    status: "waiting",
  },
  termination: {
    name: "termination",
    status: "waiting",
  },
  "notification triggered": {
    name: "notification triggered",
    status: "waiting",
  },
  "notification received In-App": {
    name: "notification received In-App",
    comments: "Did you receive notification from the app ?",
    input: {
      clicked: false,
      dependency: "notification triggered",
    },
  },
  "notification received WhatsApp": {
    name: "notification received WhatsApp",
    comments: "Did you receive notification from WhatsApp ?",
    input: {
      clicked: false,
      dependency: "notification triggered",
    },
  },
};

const dndTemplate = {
  connectivity: {
    name: "connectivity",
    status: "running",
  },
  "requests sent": {
    name: "requests sent",
    status: "waiting",
  },
  notification: {
    name: "notification",
    status: "waiting",
  },
  "voice prompt": {
    name: "voice prompt",
    comments: "did you hear any voice prompt ?",
    input: {
      clicked: false,
      dependency: "requests sent",
    },
  },
};

const rebootTemplate = {
  connectivity: {
    name: "connectivity",
    status: "running",
  },
  "reboot payload": {
    name: "reboot payload",
    status: "waiting",
  },
  disconnection: {
    name: "disconnection",
    status: "waiting",
  },
  reconnection: {
    name: "reconnection",
    status: "waiting",
  },
  reboot: {
    name: "reboot",
    comments: "did the device reboot?",
    input: {
      clicked: false,
      dependency: "reconnection",
    },
  },
};

const pulseCalibrationTemplate = {
  connectivity: {
    name: "connectivity",
    status: "running",
  },
  "current volume": {
    name: "current volume",
    status: "waiting",
  },
  "calibration sent": {
    name: "calibration sent",
    status: "waiting",
  },
  "new volume": {
    name: "new volume",
    status: "waiting",
  },
};
